import { ConvertPriceToString } from '../../../Helpers/CustomConverter'

import '../Styles/NewPromoSellOutStyles.css'

const NewPromoSellOutOldPrice = ({ product, isThreshold, fontSize }) => {
    const oldPriceStyle = isThreshold ? 'old-price-product-threshold' : 'old-price-single-product'

    if (product.isSellOut || product.isPromo) {
        return <span style={{ fontSize: fontSize }} className={`${oldPriceStyle}`}>{ConvertPriceToString(product.priceNetBeforePromotion, product.currency)}</span>
    }
    return null
}

export default NewPromoSellOutOldPrice